module.exports = __webpack_public_path__ + "static/media/zdislava.57ab1ac6.jpg";